<template>
  <button
    v-if="enabled"
    type="button"
    class="floating-customer-service"
    :style="positionStyle"
    :aria-label="$t('webindex.custserver')"
    @click.stop="openService"
  >
    <img
      :src="avatar"
      alt=""
    >
  </button>
</template>

<script>
import avatar from '../views/images/shop2/kefu.jpg';

export default {
  name: 'FloatingCustomerService',
  props: {
    serviceUrl: {
      type: String,
      default: '',
    },
    bottom: {
      type: Number,
      default: 70,
    },
  },
  data() {
    return {
      avatar: avatar,
    };
  },
  computed: {
    enabled() {
      return String(this.serviceUrl || '').trim().length > 0;
    },
    positionStyle() {
      return {
        '--floating-customer-service-bottom': Math.max(0, Number(this.bottom) || 0) + 'px',
      };
    },
  },
  methods: {
    openService() {
      this.$router.push('/kefu');
    },
  },
};
</script>

<style scoped>
.floating-customer-service {
  position: fixed;
  right: 13px;
  bottom: calc(var(--floating-customer-service-bottom) + env(safe-area-inset-bottom, 0px));
  z-index: 1100;
  width: 60px;
  height: 60px;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .22);
  cursor: pointer;
}

.floating-customer-service img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
